import axios from 'axios';
import { useMessage } from '@/hooks/useMessage';
import store from '@/store';

const service = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
  // 根据项目所处的环境，自动加载所需的url地址 使用了proxy 代理服务器就不用basseURl
  baseURL: process.env.VUE_APP_URL,

  // 请求超时时间
  timeout: 1000 * 60 * 2, // 2分钟
});

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    const token = store.state.user.token;
    // 公开接口不自动带 token（避免过期 token 导致 401）
    const publicPaths = ['/user/login', '/user/register', '/user/check-username', '/email/send-code', '/email/verify-code', '/auth/login'];
    const isPublic = publicPaths.some(p => config.url.includes(p));
    if (token && !isPublic) {
      config.headers.Authorization = token;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// 从多种后端响应格式中提取错误消息
function extractMsg(err, fallback) {
  return (
    err.response?.data?.data?.message ||
    err.response?.data?.message ||
    fallback
  );
}

service.interceptors.response.use(
  // HTTP 2xx：直接解包返回 response.data
  // 业务码（code !== 0/200）由调用方通过 handleAction / isBizError 处理
  (response) => {
    return response.data;
  },
  // HTTP 4xx/5xx、网络错误、超时
  (err) => {
    let msg;

    if (err.response) {
      const status = err.response.status;
      switch (status) {
        case 400:
          msg = extractMsg(err, '请求参数错误');
          break;
        case 401:
          msg = '登录已过期，请重新登录';
          if (!window.location.pathname.includes('/login')) {
            store.commit('user/logout');
          }
          break;
        case 403:
          msg = '没有权限执行此操作';
          break;
        case 404:
          msg = '请求的资源不存在';
          break;
        case 500:
          msg = '服务器内部错误，请稍后重试';
          break;
        case 502:
          msg = '网关错误，服务正在重启';
          break;
        case 503:
          msg = '服务暂不可用，请稍后重试';
          break;
        default:
          msg = extractMsg(err, `请求失败（${status}）`);
      }
    } else if (err.code === 'ECONNABORTED') {
      msg = '请求超时，请检查网络连接后重试';
    } else if (err.message?.includes('Network Error')) {
      msg = '网络错误，请检查网络连接或稍后重试';
    } else {
      msg = '请求异常，请稍后重试';
    }

    // 登录接口的业务错误由登录页自己展示，不在这里弹窗
    const isLoginRequest = err.config?.url?.includes('/auth/login');
    if (!isLoginRequest) {
      useMessage(msg, 'error');
    }
    // 标记该错误已由拦截器统一弹窗，供 apiHelper.isBizError 识别，
    // 避免组件 catch 里再弹一次造成双提示
    err._handledByInterceptor = true;
    // 统一 reject，保证 .catch() 能正确捕获
    return Promise.reject(err);
  }
);

export default service;
